import { formatDate } from '@brandbank/portal-components';

export const unCamelCase = (s: string): string => {
  const result = s
    // insert a space between lower & upper
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([0-9])([A-Z])/g, '$1 $2') // IPv4Addresses => IPv4 Addresses
    // space before last upper in a sequence followed by lower
    .replace(/\b([A-Z]+)([A-Z])([a-z][^0-9])/, '$1 $2$3') // IPv4 Addresses != I Pv4 Addresses
    .replace(/\bId\b/, 'ID')
    // uppercase the first character
    .replace(/^./, (str) => str.toUpperCase())
    // uppercase all the space lowercase chars
    .replace(/ ([a-z])/g, (str) => str.toUpperCase());

  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const asDate = (str: string | null) =>
  str ? formatDate(str, true) : null;

export const capitalizeFirstChar = (str: string) => {
  return str
    ? str.charAt(0).toUpperCase() + str.slice(1).replace(/-/g, ' ')
    : str;
};
